export var VirtualWellPlateMode;
(function (VirtualWellPlateMode) {
    VirtualWellPlateMode[VirtualWellPlateMode["RESULTS"] = 0] = "RESULTS";
    VirtualWellPlateMode[VirtualWellPlateMode["NAVIGATION"] = 1] = "NAVIGATION";
    VirtualWellPlateMode[VirtualWellPlateMode["GROUPING"] = 2] = "GROUPING";
    VirtualWellPlateMode[VirtualWellPlateMode["PROCESSING"] = 3] = "PROCESSING";
})(VirtualWellPlateMode || (VirtualWellPlateMode = {}));
